import React from "react";
import { Checkbox, Input, Radio, Select } from "antd";

import { Field, YesNo } from "./fields";

/**
 * Step 2 — the money rules.
 *
 * Their form tracks exactly TWO maximum pools (Basic and Major, optionally
 * combined) rather than one per category. That is the distinction our current
 * four-card UI loses: a dollar pool and a coverage percentage are different
 * things, and several families share one pool.
 */
export default function MoneyStep({ value, onChange }) {
  function set(k, v) { onChange(Object.assign({}, value, { [k]: v })); }
  const months = [];
  for (let i = 1; i <= 12; i++) months.push(("0" + i).slice(-2));

  return (
    <div className="bw-card">
      <p className="bw-card-title">Maximums, deductible &amp; fee guide</p>
      <div className="bw-grid">
        <Field label="Fee guide" hint="Current, or a year behind — the shortform writes FG-C or FG-1.">
          <Radio.Group
            value={value.feeGuide || ""}
            onChange={function (e) { set("feeGuide", e.target.value); }}
            optionType="button" buttonStyle="solid"
            options={[{ label: "Current", value: "C" }, { label: "1 year behind", value: "-1" }]}
          />
        </Field>
        <Field label="Specialist fee covered">
          <YesNo value={value.specialistFee || ""} onChange={function (v) { set("specialistFee", v); }} />
        </Field>
        <Field label="Basic maximum">
          <Input prefix="$" value={value.maxBasic || ""} onChange={function (e) { set("maxBasic", e.target.value); }} />
        </Field>
        <Field label="Major maximum">
          <Input prefix="$" value={value.maxMajor || ""} onChange={function (e) { set("maxMajor", e.target.value); }} />
        </Field>
        <Field label="Shared pool" hint="When combined, Basic and Major draw down one maximum.">
          <Checkbox checked={!!value.maxCombined} onChange={function (e) { set("maxCombined", e.target.checked); }}>
            Combined
          </Checkbox>
        </Field>
        <Field label="Deductible — single">
          <Input prefix="$" value={value.deductibleSingle || ""} onChange={function (e) { set("deductibleSingle", e.target.value); }} />
        </Field>
        <Field label="Deductible — family">
          <Input prefix="$" value={value.deductibleFamily || ""} onChange={function (e) { set("deductibleFamily", e.target.value); }} />
        </Field>
        <Field label="Plan renews" hint="The benefit-year boundary every maximum resets on." span>
          <div className="bw-inline">
            <Select style={{ width: 96 }} placeholder="MM" value={value.renewsMonth || undefined}
              onChange={function (v) { set("renewsMonth", v); }}
              options={months.map(function (m) { return { value: m, label: m }; })} />
            <Input style={{ width: 88 }} placeholder="DD" value={value.renewsDay || ""}
              onChange={function (e) { set("renewsDay", e.target.value); }} />
            <Input style={{ width: 110 }} placeholder="YYYY" value={value.renewsYear || ""}
              onChange={function (e) { set("renewsYear", e.target.value); }} />
          </div>
        </Field>
      </div>
    </div>
  );
}
